module.exports = __webpack_public_path__ + "static/img/title@2x.b60538f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/JuneRecharge/title@2x.png
// module id = OC+w
// module chunks = 69